import type { Inventory } from '@libs/common-node';
import { logger } from '@libs/core';
import { client } from '../../client';
import { CWEA_ENDPOINTS } from '../../constants';

export async function getProductInventoryPairs(storesku?: { store: string; sku: string }[]) {
    if (!Array.isArray(storesku) || storesku.length === 0) {
        logger.warn(`[getProductInventoryPairs] storesku is undefined or empty.\n`);
        return [];
    }

    const filteredStoresku = storesku.filter(({ store, sku }) => Boolean(store?.trim() && sku?.trim()));

    if (filteredStoresku.length === 0) {
        logger.warn(`[getProductInventoryPairs] filteredStoresku or empty after filter invalid sku-store.\n`);
        return [];
    }

    const url = CWEA_ENDPOINTS.inventory.getProductInventoryPairs;
    try {
        return (
            (await client.cwea<Inventory[]>(url, {
                method: 'POST',
                body: JSON.stringify({ storesku: filteredStoresku }),
            })) ?? []
        );
    } catch (error) {
        logger.error(`[getProductInventoryPairs] Error fetching product inventory pairs:\n ${error}`);
        return [];
    }
}
